export interface DossierExternalReferences {
  horizonsId?: string;
  damageId?: string;
}
